export const TOGGLE_VISIBILITY = 'TOGGLE_VISIBILITY';
export const RESET = 'RESET';
export const OPEN_TOASTER = 'OPEN_TOASTER';
